import AwsLogo from "../../assets/images/aws.png"; // Add AWS logo
import CloudLogo from "../../assets/images/cloud.png"; // Add Cloud Services logo
import Diamond from "../../assets/images/diamond.png";
import ElementorImg from "../../assets/images/elementor.png";
import FigmaImg from "../../assets/images/figma.png";
import flutterImg from "../../assets/images/flutter.jpg";
import HtmlLogo from "../../assets/images/html-logo.png";
import IllustratorImg from "../../assets/images/illustrator.png";
import JsLogo from "../../assets/images/js-logo.png";
import MySqlLogo from "../../assets/images/mysql.png"; // Add MySQL logo
import PhotoShop from "../../assets/images/photoshop.png";
import PythonLogo from "../../assets/images/python.png"; // Add Python logo
import ReactLogo from "../../assets/images/react.jpg";
import WordpressImg from "../../assets/images/wordpress.png";
import { useEffect, useRef } from "react";

function applySkillTilt(el, clientX, clientY) {
  if (!el) return;
  const rect = el.getBoundingClientRect();
  const x = clientX - rect.left;
  const y = clientY - rect.top;
  const px = x / rect.width - 0.5;
  const py = y / rect.height - 0.5;

  const max = 10;
  const ry = px * max;
  const rx = -py * max;

  const mx = Math.max(0, Math.min(100, (x / rect.width) * 100));
  const my = Math.max(0, Math.min(100, (y / rect.height) * 100));

  el.style.setProperty("--rx", `${rx.toFixed(2)}deg`);
  el.style.setProperty("--ry", `${ry.toFixed(2)}deg`);
  el.style.setProperty("--mx", `${mx.toFixed(2)}%`);
  el.style.setProperty("--my", `${my.toFixed(2)}%`);
}

const SectionFour = () => {
  const cardRefs = useRef([]);

  useEffect(() => {
    const prefersReduced =
      window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
    if (prefersReduced) return;

    let raf = 0;
    const tick = (t) => {
      // gentle oscillating rotation so it keeps "rotating" without being distracting
      cardRefs.current.forEach((el, idx) => {
        if (!el) return;
        const deg = Math.sin(t / 1100 + idx * 0.65) * 6; // -6deg..+6deg
        el.style.setProperty("--spin", `${deg.toFixed(2)}deg`);
      });
      raf = requestAnimationFrame(tick);
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);

  const onSkillMove = (e) => {
    applySkillTilt(e.currentTarget, e.clientX, e.clientY);
  };

  const onSkillLeave = (e) => {
    const el = e.currentTarget;
    el.style.setProperty("--rx", "0deg");
    el.style.setProperty("--ry", "0deg");
    el.style.setProperty("--mx", "50%");
    el.style.setProperty("--my", "50%");
  };

  const setCardRef = (el) => {
    if (!el) return;
    cardRefs.current.push(el);
  };

  const skills = [
    { img: WordpressImg, alt: "wordpress", label: "WORDPRESS" },
    { img: ElementorImg, alt: "elementor", label: "ELEMENTOR" },
    { img: HtmlLogo, alt: "html-logo", label: "HTML5" },
    { img: JsLogo, alt: "js-logo", label: "JAVASCRIPT" },
    { img: FigmaImg, alt: "figma", label: "FIGMA" },
    { img: Diamond, alt: "diamond", label: "SKETCH" },
    { img: PhotoShop, alt: "photoshop", label: "PHOTOSHOP" },
    { img: IllustratorImg, alt: "illustrator", label: "ILLUSTRATOR" },
    { img: ReactLogo, alt: "react-logo", label: "REACT" },
    { img: flutterImg, alt: "flutter-logo", label: "FLUTTER" },
    { img: PythonLogo, alt: "python-logo", label: "PYTHON" },
    { img: MySqlLogo, alt: "mysql-logo", label: "MYSQL" },
    { img: AwsLogo, alt: "aws-logo", label: "AWS" },
    { img: CloudLogo, alt: "cloud-logo", label: "CLOUD" },
  ];

  return (
    <>
      {/* <!-- ====================================== Section Four ===================================== --> */}
      <section className="section-four overflow-hidden">
        <div className="container">
          <p className="our-services my_skills" data-aos="fade-up">
            Our SKILLS
          </p>
          <h2 className="our-solution my-expertise" data-aos="fade-down">
            Our Expertise.
          </h2>
          <div className="skill-type-main">
            {skills.map((s, idx) => (
              <div
                key={`${s.label}-${idx}`}
                className="skills-box-main"
                data-aos="flip-left"
                data-aos-easing="ease-out-cubic"
                data-aos-duration="2000"
                data-skill={s.label}
                onPointerMove={onSkillMove}
                onPointerLeave={onSkillLeave}
                ref={setCardRef}
              >
                <img src={s.img} alt={s.alt} />
                <div className="counter">
                  <p>{s.label}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* <!-- ====================================== Section Four End ===================================== --> */}
    </>
  );
};
export default SectionFour;
